// Company contact details (offices, phone, email) shown across the site —
// footer, contact page, and JSON-LD. The canonical source is the Strapi
// "Company Info" single type (see getCompanyInfo); these values are the
// fallback used when Strapi is unreachable or empty, so the address never
// renders blank. Keep them in sync with the Strapi seed.

export type IOffice = {
  label: string;
  streetAddress: string;
  addressLocality: string;
  addressRegion?: string;
  postalCode?: string;
  addressCountry?: string;
  isHeadquarters?: boolean;
};

export type ICompanyInfo = {
  phone: string;
  email: string;
  offices: IOffice[];
};

export const COMPANY_INFO_FALLBACK: ICompanyInfo = {
  phone: "+91 79848 18161",
  email: "inquiry@certbar.com",
  offices: [
    {
      label: "Surat (HQ)",
      streetAddress: "409-410, Sunday Hub, Ambatalavdi",
      addressLocality: "Surat",
      addressRegion: "Gujarat",
      postalCode: "395004",
      addressCountry: "IN",
      isHeadquarters: true,
    },
    {
      label: "Mumbai",
      streetAddress:
        "802 - 72 Corp, Beside Saki Naka Metro Station, Andheri East",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      postalCode: "400072",
      addressCountry: "IN",
      isHeadquarters: false,
    },
  ],
};

// "Locality, Region - Postal" — the region/postal tail shown under the street.
export const officeRegionLine = (o: IOffice): string => {
  const tail = [o.addressRegion, o.postalCode].filter(Boolean).join(" - ");
  return [o.addressLocality, tail].filter(Boolean).join(", ");
};

// Single-line address for compact contexts.
export const formatOfficeAddress = (o: IOffice): string =>
  [o.streetAddress, officeRegionLine(o)].filter(Boolean).join(", ");

// tel: href from a display phone (keep leading +, drop spaces/dashes).
export const telHref = (phone: string): string =>
  `tel:${phone.replace(/[^\d+]/g, "")}`;
